import React from "react";
import { Container } from "reactstrap";
import "./Loader.css"; // Ensure you have the appropriate styles
import logo from "./assets/images/logo-light.png"; // Import logo correctly

const Loader = () => {
  return (
    <Container className="loader-container">
      <img src={logo} alt="Logo" className="loader-logo mb-4" />
      <br />
      <div className="loader">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        
      </div>
    </Container>
  );
};

export default Loader;
